import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import GidiIcon from '../components/GidiIcon';
import ImageWithLoader from '../components/ImageWithLoader';
import './About.css';

const About: React.FC = () => {
  const [isCompact, setIsCompact] = useState(false);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  // Handle scroll to make navigation compact
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsCompact(scrollTop > 100); // Make compact after scrolling 100px
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="about">
      <nav className={`nav ${isCompact ? 'compact' : ''}`}>
        <Link to="/" className="nav-link-special">
          <GidiIcon size={27} />
        </Link>
        <Link to="/projects" className="nav-link">projects</Link>
      </nav>
      
      <div className="about-content">
        <div className="about-header">
          <h1>In short,</h1>
          <svg className="underline-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 247.51 24.43">
            <defs>
              <style>{`.cls-1{fill:#ffc200;stroke-width:0px;}`}</style>
            </defs>
            <g id="Layer_1-2">
              <path className="cls-1" d="M4.48,17.38c6.26-3.65,12.95-6.45,19.91-8.47,3.67-1.07,7.41-1.94,11.18-2.58,1.51-.26,3.14-.47,4.66-.24.68.1,1.22.29,1.73.59.13.08.27.16.39.25-.06-.04-.27-.22-.03,0,.13.12.63.75.36.35.18.27.33.55.48.84s0-.03-.02-.08c.06.13.1.26.15.39.21.58.38,1.17.54,1.77.38,1.37.76,2.71,1.36,4.01,1.33,2.9,4.08,4.83,7.14,5.55,3.41.8,6.95.44,10.36-.16,3.8-.67,7.54-1.7,11.29-2.6,8.19-1.95,16.37-3.91,24.56-5.86,1.98-.47,3.96-1,5.96-1.4,1.32-.27,2.91-.56,4.13,0-.17-.08.46.31.23.15.29.21.19.14.42.54.25.43.34.79.59,1.52.46,1.36,1,2.63,1.88,3.78,3.41,4.46,9.42,5.64,14.72,5.91,6.18.32,12.33-.7,18.36-1.97,8.08-1.7,16.15-3.58,24.27-5.07,3.52-.65,7.3-1.12,10.84-.35,1.43.31,2.69.8,3.75,1.6.3.23.88.78,1.22,1.2.22.28.03.05-.01,0,.08.12.16.25.24.37s.14.25.21.38c-.13-.27-.05-.18.02.05.05.17.1.34.14.52,0-.03-.09-.5-.02-.15.02.13,0,.26,0,.39,0-.03.08-.52.02-.16-.02.13-.06.25-.1.38.02-.05.2-.41.03-.1-.07.12-.14.24-.22.36.08-.12.31-.36-.11.08-1.92,2.03-.4,4.85,2.12,5.12,8.18.89,16.16-1.58,23.71-4.43,6.83-2.58,13.7-5.42,21.06-5.93,3.74-.26,7.63-.02,11.05,1.58,1.47.69,3.24.41,4.1-1.08.76-1.3.4-3.41-1.08-4.1-7.22-3.38-15.35-2.84-22.91-.98-7.73,1.91-14.87,5.55-22.54,7.65-4.4,1.2-8.84,1.79-13.4,1.29l2.12,5.12c2.4-2.52,2.73-6.01.97-9s-5.03-5.02-8.34-5.83c-8.21-2.01-16.99.75-25.02,2.44-4.25.9-8.5,1.79-12.75,2.69-1.77.37-3.53.76-5.3,1.08-1.62.29-2.61.43-4.14.59-3.02.32-6.08.46-9.11.23-1.51-.11-2.15-.18-3.73-.56-.57-.14-1.13-.29-1.69-.48-.18-.06-.88-.32-.69-.24s-.48-.22-.63-.3c-.5-.26-.98-.55-1.44-.88-.28-.2.08.06.11.09-.09-.08-.19-.16-.28-.24-.24-.23-.47-.46-.69-.7-.08-.09-.16-.18-.24-.28.03.04.27.4.11.12-.14-.25-.3-.48-.44-.74-.19-.35,0,.05-.18-.39-.15-.4-.27-.82-.42-1.22-.56-1.62-1.27-3.19-2.61-4.31-1.65-1.39-3.74-1.95-5.87-1.95-4.07,0-8.25,1.47-12.18,2.4-4.25,1.01-8.51,2.03-12.76,3.04s-8.67,2.07-13,3.1c-3.49.83-7.07,1.87-10.59,2.14-1.49.11-3.12.12-4.33-.14-.39-.08-.77-.19-1.15-.32-.15-.05-.15-.03-.5-.21-.78-.41-.89-.5-1.39-1.07-.23-.26-.03-.03.01.03-.11-.16-.22-.32-.31-.49-.14-.25-.28-.51-.39-.77.19.43-.07-.22-.12-.36-.12-.36-.23-.74-.34-1.11-.34-1.19-.63-2.39-1.1-3.53-1.5-3.64-4.5-5.66-8.39-6.09s-8.01.65-11.77,1.5c-7.68,1.75-15.17,4.38-22.21,7.89-1.69.84-3.36,1.75-4.99,2.7-3.33,1.95-.32,7.13,3.03,5.18h0Z"/>
            </g>
          </svg>
        </div>
        
        <div className="about-main">
          <div className="about-intro-wrap">
            <ImageWithLoader 
              src="/Drawing With Hands.gif" 
              alt="Drawing With Hands" 
              className="gif-circle about-float-img"
              loaderSize={40}
            />
            <div className="about-text">
              <p>
                I am a Creative Technologist, interested in developing new ways that humans can interact with technology. I have worked on a range of projects from Augmented Reality to Digital Fabrication and Full Stack Development, and I am always looking for new challenges that push the boundaries of Human Computer Interaction.
              </p>
            </div>
          </div>
          <div className="about-text about-second-paragraph">
            <p>
              Additionally, I love roasting coffee, cooking, hiking and reading philosophy (recently lots of Bertrand Russell). 
            </p>
          </div>
          <div className="gif-row">
            <ImageWithLoader 
              src="/CoffeeMaking.gif" 
              alt="Making Coffee" 
              className="gif-circle"
              loaderSize={40}
            />
          </div>
          <div className="contact-links">
            <a href="https://www.linkedin.com/in/gideonrubin1/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            <a href="mailto:gidierubin@gmail.com">Email</a>
            <a href="/Gidi Rubin Resume.pdf" download>Resume</a>
          </div>
        </div>

        {/* Experience Section */}
        <div className="experience-section">
          <h2>Experience</h2>
          
          <div className="experience-item">
            <div className="experience-header">
              <h3>Augmented Reality Engineer</h3>
              <div className="company-info">
                <span className="company">Snap Inc.</span>
                <span className="employment-type">Full-time</span>
              </div>
              <div className="date-location">
                <span className="date">May 2022 - Present · 3 yrs 4 mos</span>
                <span className="location">Tel Aviv, Israel</span>
              </div>
            </div>
            <p className="description">
              Working as a Creative Technologist for a high-impact deep learning team, I have worked on a range of projects from Virtual Try-On to combining GenAI and AR in a tool called EasyLens that allows developers to build AR experiences through a text prompt. My team's work has featured in publications like TechCrunch.
              <br/>I have also run workshops through the Royal College of Art and Snap's Lens Lab collaboration.
            </p>
          </div>

          <div className="experience-item">
            <div className="experience-header">
              <h3>Fellow</h3>
              <div className="company-info">
                <span className="company">Nevo Network</span>
              </div>
              <div className="date-location">
                <span className="date">Aug 2024 - Jul 2025 · 1 yr</span>
              </div>
            </div>
            <p className="description">
              Selected as part of the fifth cohort of Nevo Network fellows, backed by Michael Eisenberg. 
              Ran a hackathon for 150 participants, focusing on improving the lives of Israeli immigrants through technology.
            </p>
          </div>

          <div className="experience-item">
            <div className="experience-header">
              <h3>Software Engineer</h3>
              <div className="company-info">
                <span className="company">ResMed</span>
                <span className="employment-type">Full-time</span>
              </div>
              <div className="date-location">
                <span className="date">Nov 2020 - Jan 2022 · 1 yr 3 mos</span>
                <span className="location">Australia</span>
              </div>
            </div>
            <p className="description">
              Working in a full-stack role (Angular/React, Java/Node.js, AWS) I have been involved in Resmed's Digital Health Technology group, contributing towards its remote therapy capabilities. Additionally, I was involved in the UX / UI design for various major and minor products.
            </p>
          </div>

          <div className="experience-item">
            <div className="experience-header">
              <h3>Research Assistant - Human Robot Interaction</h3>
              <div className="company-info">
                <span className="company">CSIRO</span>
                <span className="employment-type">Internship</span>
              </div>
              <div className="date-location">
                <span className="date">Oct 2020 - May 2021 · 8 mos</span>
              </div>
            </div>
            <p className="description">
              Examining and summarising literature related to the uses of social robots in various care-giving roles. Exploring methods of virtually testing robotic interaction and emotional adaptation, using python, opencv, gpt3 and choregraphe.
            </p>
          </div>

          <div className="experience-item">
            <div className="experience-header">
              <h3>Technical Assistant - Digital Fabrication</h3>
              <div className="company-info">
                <span className="company">Monash University</span>
                <span className="employment-type">Part-time</span>
              </div>
              <div className="date-location">
                <span className="date">Mar 2019 - Nov 2020 · 1 yr 9 mos</span>
                <span className="location">Digital Fabrication Workshop, Monash Caulfield Campus</span>
              </div>
            </div>
            <p className="description">
              Operating / programming, maintaining and assisting students and research staff with 3D printers (SLA and FDM), 7 axis robot arms (KUKA IIWA), laser cutters and other cutting edge methods of digital fabrication.
            </p>
          </div>

          <div className="experience-item">
            <div className="experience-header">
              <h3>Research Assistant - Embedded Electronics</h3>
              <div className="company-info">
                <span className="company">SensiLab, Monash University</span>
                <span className="employment-type">Part-time</span>
              </div>
              <div className="date-location">
                <span className="date">Feb 2020 - Apr 2020 · 3 mos</span>
              </div>
            </div>
            <p className="description">
              Assisting with testing and development of embedded sensors (through building testing rigs, data analysis and calibration) for use in medical research.
            </p>
          </div>

          <div className="experience-item">
            <div className="experience-header">
              <h3>Software Engineer Intern</h3>
              <div className="company-info">
                <span className="company">National Australia Bank</span>
              </div>
              <div className="date-location">
                <span className="date">Jul 2019 - Dec 2019 · 6 mos</span>
              </div>
            </div>
            <p className="description">
              Engaging in front-end and back-end software development using a range of tools including AWS services, Node.js, React and Java to help develop enterprise software as part of my Industry Based Learning scholarship.
            </p>
          </div>

          <div className="experience-item">
            <div className="experience-header">
              <h3>Winter Research Scholar</h3>
              <div className="company-info">
                <span className="company">SensiLab, Monash University</span>
              </div>
              <div className="date-location">
                <span className="date">Jul 2018 - Aug 2018 · 2 mos</span>
                <span className="location">Monash University, Victoria, Australia</span>
              </div>
            </div>
            <p className="description">
              Taking part in an interdisciplinary project requiring the designing and engineering of an interactive exhibit for winter open day 2018. The project involved development of software (Arduino, C#, pd) and hardware (3D printing and laser cutting) to create an installation that connected both campuses through various interactions.
            </p>
          </div>
        </div>

        {/* Education Section */}
        <div className="education-section">
          <h2>Education</h2>
          
          <div className="education-item">
            <div className="education-header">
              <h3>Bachelor of Design, Industrial Design</h3>
              <div className="school-info">
                <span className="school">Monash University</span>
              </div>
              <div className="date-location">
                <span className="date">Jan 2017 - Jul 2020</span>
              </div>
            </div>
          </div>

          <div className="education-item">
            <div className="education-header">
              <h3>Bachelor of Information Technology, Software Development</h3>
              <div className="school-info">
                <span className="school">Monash University</span>
              </div>
              <div className="date-location">
                <span className="date">2017 - 2020</span>
              </div>
            </div>
          </div>
          
        </div>

        {/* Awards and Scholarships Section */}
        <div className="awards-section">
          <h2>Awards and Scholarships</h2>
          
          <div className="award-item">
            <div className="award-header">
              <h3>Designers Australia Awards - Award of Merit</h3>
              <div className="award-info">
                <span className="award-issuer">Design Institute of Australia</span>
                <span className="award-date">2023</span>
              </div>
            </div>
            <p className="description">
              Awarded for the SensiLab Drawbotic DB-1 drawing robots platform project. The project explored what art made by autonomous, non-human intelligence might look like and how robots might exhibit creative behavior. 
             <br/> <a href="https://www.awards.design.org.au/award-of-merit-2023-1/sensilab-monash-art-design-and-architecture-for-drawbotic-db-1-a-drawing-robots-platform" target="_blank" rel="noopener noreferrer">View award details</a>
            </p>
          </div>

          <div className="award-item">
            <div className="award-header">
              <h3>New Colombo Plan Scholarship</h3>
              <div className="award-info">
                <span className="award-issuer">Monash University</span>
                <span className="award-date">Dec 2019</span>
              </div>
            </div>
            <p className="description">
              I was selected as part of a small team to help develop an educational robot for Monash University in Shenzhen, China, engaging in interdisciplinary practice-based research to investigate design for mass manufacture.
            </p>
          </div>

          <div className="award-item">
            <div className="award-header">
              <h3>Industry Based Learning Scholarship</h3>
              <div className="award-info">
                <span className="award-issuer">Monash University</span>
                <span className="award-date">Jul 2019</span>
              </div>
            </div>
            <p className="description">
              Associated with National Australia Bank. Awarded for project-based academic excellence.
            </p>
          </div>

          <div className="award-item">
            <div className="award-header">
              <h3>Award for Project-Based Academic Excellence</h3>
              <div className="award-info">
                <span className="award-issuer">Monash University</span>
                <span className="award-date">Nov 2018</span>
              </div>
            </div>
            <p className="description">
              I was awarded the student prize for my final project involving modular textured panels that were generatively designed using evolutionary algorithms to acoustically optimise interior spaces by reducing coherent echoes, providing both ornamental and functional value.
            </p>
          </div>

          <div className="award-item">
            <div className="award-header">
              <h3>Winter Research Scholarship</h3>
              <div className="award-info">
                <span className="award-issuer">Monash University, Faculty of Information Technology</span>
                <span className="award-date">Aug 2018</span>
              </div>
            </div>
            <p className="description">
              Associated with SensiLab, Monash University. As part of a team of 4 students, I engaged in design and engineering work towards an interactive installation that connected Monash Caulfield and Clayton campuses through various audio and tactile interactions with 'hacked' vintage phones.
            </p>
          </div>

          <div className="award-item">
            <div className="award-header">
              <h3>Commendation for General Academic Excellence</h3>
              <div className="award-info">
                <span className="award-issuer">Monash University, Faculty of Architecture & Design</span>
                <span className="award-date">Dec 2017</span>
              </div>
            </div>
            <p className="description">
              Awarded for a design project, utilising generative design as a tool to reinterpret my grandfather's traditional pottery work.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
